import i18n from 'services/base/i18n';

export default {
  // The title for this page
  title: () => i18n.pgettext('Pages|Add Pangolin|Method', 'Register Your Pangolin'),

  // Error message to display when someone submits an invalid QR Code
  invalidQRCodeError: () => i18n.pgettext('Pages|Add Pangolin|Method', 'Invalid QR Code. It is possible that someone else has already claimed this Pangolin.'),

  // Error message to display when something else goes wrong
  systemError: () => i18n.pgettext('Pages|Add Pangolin|Method', 'Unable to connect to the server. Please try again.'),

  // A button that lets the user scan a QR code on their Pangolin
  qrCode: () => i18n.pgettext('Pages|Add Pangolin|Method', 'via QR Code'),

  // A button that takes the user to a form where they input the secret activation phrase
  secretPhrase: () => i18n.pgettext('Pages|Add Pangolin|Method', 'via Secret Phrase'),
};
